import { PhoneInputField } from '@/components/common/PhoneInputField';

import type { ProfesionalFormValues } from '../schemas';
import type { Control } from 'react-hook-form';

interface PhoneFieldProps {
  control: Control<ProfesionalFormValues>;
  label?: string;
  disabled?: boolean;
}

export function PhoneField({ control, label = 'Teléfono / WhatsApp', disabled = false }: PhoneFieldProps): JSX.Element {
  return (
    <PhoneInputField
      control={control}
      name="telefono_whatsapp"
      label={label}
      disabled={disabled}
    />
  );
}
